import { render, staticRenderFns } from "./LazyButton.vue?vue&type=template&id=496956a4"
import script from "./LazyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports